export default "/images/crypto_environments/ethereum_audit_4.png";